module.exports = __webpack_public_path__ + "media/images/email-f4915b9135ad2c09bee27f7ce9da5e77.svg";